import React from 'react';

import type { WidgetProps } from '../../../types/WidgetProps';

import { HawkWidgetAdvancedProps } from './HawkWidgetAdvanced/model';
import HawkWidgetContextProvider from './HawkWidgetContextProvider';

interface HawkWidgetStandardProps {
  dealData: WidgetProps['dealData'];
  data: WidgetProps['data'];
  tabConfigs: WidgetProps['tabConfigs'];
  defaultTab: WidgetProps['defaultTab'];
}

const HawkWidgetStandard: React.FC<HawkWidgetStandardProps> = (props) => {
  const { dealData, data, tabConfigs, defaultTab } = props;

  return (
    <HawkWidgetContextProvider
      {...{
        // TODO(Petr): HAWK-7003 remove cast
        ...(props as unknown as HawkWidgetAdvancedProps),
        dealData,
        tabs: tabConfigs,
        data: data && defaultTab ? data[defaultTab.value] : {},
        activeTab: defaultTab,
      }}
    />
  );
};

export default HawkWidgetStandard;
